<template>
  <div class="row mt-3">
    <div class="col-4">
      <div class="form-group">
        <label for="identificadorSolicitante"
               class="label">
          N° Pedido CRC, OS, CPF/CNPJ ou nome do solicitante
        </label>

        <input id="identificadorSolicitante"
               v-model="formData.identificadorSolicitante"
               type="text"
               class="form-control form-control-sm">
      </div>
    </div>

    <div class="col-3 d-flex align-items-end">
      <div class="form-group w-100">
        <label for="data_ordem_servico"
               class="label">
          Data OS
        </label>

        <input id="data_ordem_servico"
               v-model="formData.data_cumprida"
               type="date"
               class="form-control form-control-sm">
      </div>
    </div>

    <div class="col-3 d-flex align-items-end">
      <div class="form-group w-100">
        <label for="status_ordem_servico"
               class="label">
          Status
        </label>
        <v-select id="status_ordem_servico"
                  v-model="opcaoEscolhida"
                  class="form-control form-control-sm"
                  :options="opcoesDeStatus"
                  @input="formatandoStatusEscolhido" />
      </div>
    </div>

    <div class="col-2 d-flex align-items-end">
      <div class="form-group mt-3">
        <div class="row">
          <div class="col">
            <button class="btn btn-sm btn-outline-primary mt-2"
                    @click="propRegistroId ? search() : $emit('buscaManual', { ...formData })">
              Pesquisar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* services */
  import OrdensServicoService from "@/services/Registros/OrdensServicoService"

  import { mapGetters } from "vuex"

  export default {
    name: "OrdensServicoSearch",
    props: {
      propRegistroId: {type: Number, default: null}
    },
    data () {
      return {
        formData: {
          identificadorSolicitante: null,
          data_cumprida: null,
          status_selos: null
        },
        opcaoEscolhida: null,
        opcoesDeStatus: ['Todos', 'Selos não enviados', 'Selos enviados', 'Selos pendentes'],
        opcoesFormatadas: {
          'Todos': 'todos',
          'Selos não enviados': 'selos_nao_enviados',
          'Selos enviados': 'selos_enviados',
          'Selos pendentes': 'PENDENTE'
        }
      }
    },
    computed: {
      ...mapGetters({
        exibirSelosNaoEnviados: 'statusDosSelos/getSelosNaoEnviados',
        contagemDeExibicaoDosSelosNaoEnviados: 'statusDosSelos/getContagemDeExibicaoDosSelosNaoEnviados',
        contagemDeExibicaoDeTodosOsSelos: 'statusDosSelos/getContagemDeExibicaoDeTodosOsSelos'
      })
    },
    watch: {
      exibirSelosNaoEnviados () {
        this.condicaoParaExibirSelosNaoEnviados()
      },
      contagemDeExibicaoDosSelosNaoEnviados () {
        this.condicaoParaExibirSelosNaoEnviados()
      },
      contagemDeExibicaoDeTodosOsSelos () {
        this.condicaoParaExibirSelosNaoEnviados()
      }
    },
    created () {
      this.condicaoParaExibirSelosNaoEnviados()
    },
    methods: {
      async search () {
        try {
          loader({active: true})
          const response = await OrdensServicoService.getOS(this.formData, this.propRegistroId)

          this.$emit('results', response)
        } catch (error) {
          objSwal.error.title = "Não foi possível realizar a busca."
          objSwal.error.text = ''
          objSwal.error.html = ''

          Swal.fire(objSwal.error)
        } finally {
          loader({active: false})
        }
      },
      formatandoStatusEscolhido () {
        this.formData.status_selos = this.opcoesFormatadas[`${this.opcaoEscolhida}`]
      },
      condicaoParaExibirSelosNaoEnviados () {
        if (this.exibirSelosNaoEnviados) this.opcaoEscolhida = 'Selos não enviados'
        else if (!this.exibirSelosNaoEnviados) this.opcaoEscolhida = 'Todos'
        this.formatandoStatusEscolhido ()
      }
    }
  }
</script>

<style scoped>

</style>
